import { useState } from "react";
import AppForm from "components/AppForm/AppForm";
import CrudPage from "components/CrudPage/CrudPage";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import withRouter from "hoc/withRouter";
import { useLoadAll } from "hooks/useLoadAll";
import { useGetBranches } from "hooks/useGetBranches";
import { useGetTrains } from "hooks/useGetTrains";
import { useGetStations } from "hooks/useGetStations";
import { useGetCustomers } from "hooks/useGetCustomers";
import inputTypeEnum from "enums/inputTypes";
import { snack } from "components/Snack/Snack";
import baggageTripsService from "services/admin/baggageTripsService";

interface BaggageTripFormProps {
  router: any;
  data: any;
}

const BaggageTripForm = ({ router, data }: BaggageTripFormProps) => {
  const {
    navigate,
    params: { id },
  } = router;
  const { trip } = data;
  const orgID = localStorage.getItem("orgID") || "";

  const [customerSearch, setCustomerSearch] = useState("");

  const { data: branchesResponse } = useGetBranches({ orgID });
  const { data: trainsResponse } = useGetTrains({ orgID });
  const { data: stationsResponse } = useGetStations({ orgID });
  const { data: customersResponse } = useGetCustomers({ orgID, query: customerSearch });

  const branches = (branchesResponse as any)?.data || [];
  const trains = (trainsResponse as any)?.data || [];
  const stations = (stationsResponse as any)?.data || [];
  const customers = (customersResponse as any)?.data?.rows || [];

  const stationOptions = stations.map((s: any) => ({ id: s.id, name: s.name }));

  const customerName = (c: any) =>
    `${c?.lastName || ""} ${c?.firstName || ""}`.trim() || c?.name || "—";
  // Подмешиваем текущего клиента (на редактировании), чтобы его метка резолвилась
  // даже если он не попал в результаты поиска.
  const customerOptions = [...customers];
  if (trip?.customer && !customerOptions.find((x: any) => x.id === trip.customer.id)) {
    customerOptions.unshift(trip.customer);
  }

  const fieldsWithData = [
    {
      key: "customerID",
      label: "Пассажир (клиент)",
      inputType: inputTypeEnum.autocomplete,
      options: customerOptions.map((c: any) => ({ id: c.id, name: customerName(c) })),
      onChange: (text: string) => setCustomerSearch(text || ""),
    },
    {
      key: "trainID",
      label: "Поезд",
      inputType: inputTypeEnum.select,
      options: trains.map((t: any) => ({
        id: t.id,
        name: t.route ? `${t.number} — ${t.route}` : t.number,
      })),
    },
    {
      key: "originStationID",
      label: "Станция отправления",
      inputType: inputTypeEnum.select,
      options: stationOptions,
    },
    {
      key: "destinationStationID",
      label: "Станция назначения",
      inputType: inputTypeEnum.select,
      options: stationOptions,
    },
    {
      key: "departureDate",
      label: "Дата отправления",
      inputType: inputTypeEnum.date,
    },
    {
      key: "ticketNumber",
      label: "Номер билета",
      inputType: inputTypeEnum.text,
    },
  ];

  const onSubmit = async (formValues: any) => {
    try {
      if (trip) {
        await baggageTripsService.put(id, formValues);
        snack("Отправка обновлена успешно!");
      } else {
        await baggageTripsService.post(formValues);
        snack("Отправка создана успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex);
    }
  };

  return (
    <CrudPage title={trip ? "Редактирование отправки" : "Создание отправки"}>
      <AppForm onSubmit={onSubmit} data={trip} fields={fieldsWithData}></AppForm>
    </CrudPage>
  );
};
export default withRouter(
  withRemoteDataAndSpinner(BaggageTripForm, (router: any) => {
    let requests: any = {};
    if (router.params.id) {
      requests["trip"] = () => baggageTripsService.get(router.params.id);
    }
    return useLoadAll(requests);
  }),
);
